import { Box, Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import PoolSelector from "src/components/Selector/PoolSelector";
import NOURTransactionTypesOverview from "./NOURTransactionTypesOverview";
import NOURTransactionVolumeOverview from "./NOURTransactionVolumeOverview";
import TopUserByTransaction from "./TopUserByTransaction";
import TopUsersOverview from "./TopUsersOverview";
import UserActivenessOverview from "./UserActivenessOverview";
import UserAnalysisOverview from "./UserAnalysisOverview";

export default function UserAnalysis() {
  const { pool } = useParams();

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <CommonBreadcrumb config={[{ text: "analytics" }, { text: "user analysis", link: `/user-analysis/${pool}` }]} />
        <PoolSelector rootUrl="/user-analysis" />
      </Box>
      <Box mt={2} mb={2}>
        <UserAnalysisOverview />
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <UserActivenessOverview />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <NOURTransactionTypesOverview />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <NOURTransactionVolumeOverview />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <TopUsersOverview />
          </Grid>
        </Grid>
      </Box>
      <Box mt={5}>
        <TopUserByTransaction />
      </Box>
    </Box>
  );
}
